import api from "../../instance/api";
import {
  errorCity,
  errorCountry,
  errorLanguage,
  errorState,
  startCity,
  startCountryData,
  startLanguage,
  startState,
  successCity,
  successCountry,
  successLanguage,
  successState,
} from "../../slice/Location";

const getCountry = () => async (dispatch) => {
  dispatch(startCountryData());

  try {
    const res = await api.get(`/master/all-countries`);
    dispatch(successCountry(res.data));
  } catch (err) {
    dispatch(errorCountry(err?.response?.data?.message));
  }
};

const getState = (country) => async (dispatch) => {
  dispatch(startState());

  try {
    const res = await api.get(`/master/by-country/${country}`);
    dispatch(successState(res.data));
  } catch (err) {
    dispatch(errorState(err?.response?.data?.message));
  }
};

const getCity = (state) => async (dispatch) => {
  dispatch(startCity());

  try {
    const res = await api.get(`/master/by-state/${state}`);
    dispatch(successCity(res.data));
  } catch (err) {
    dispatch(errorCity(err?.response?.data?.message));
  }
};

const getLanguage = () => async (dispatch) => {
  dispatch(startLanguage());

  try {
    const res = await api.get(`/master/all-languages`);
    dispatch(successLanguage(res.data));
  } catch (err) {
    dispatch(errorLanguage(err?.response?.data?.message));
  }
};

export { getCountry, getState, getCity, getLanguage };
